import { Link } from 'react-router-dom';
import { ShareNetwork } from '@phosphor-icons/react';
import { ROUTES } from '@/utils/constants';

// Store/cart entry points are out of MVP (billing + store not wired), so the
// nav is just the wordmark + an optional share button for now.
export function CreatorNav({ onShare }: { onShare?: () => void }) {
  return (
    <nav className="ap-nav">
      <div className="ap-nav__inner">
        <Link className="ap-nav__wordmark" to={ROUTES.HOME} aria-label="Nestra">
          <svg
            className="nav-logo-mark nav-logo-mark--standalone"
            viewBox="8 8 56 56"
            role="img"
            aria-label="N"
          >
            <rect x="8" y="8" width="56" height="56" rx="13" fill="var(--ap-accent)" />
            <rect x="21" y="19" width="10" height="34" rx="5" fill="var(--ap-accent-text)" />
            <rect x="41" y="19" width="10" height="34" rx="5" fill="var(--ap-accent-text)" />
            <line
              x1="26"
              y1="24.5"
              x2="46"
              y2="47.5"
              stroke="var(--ap-accent-text)"
              strokeWidth="13"
              strokeLinecap="round"
            />
            <line
              x1="27.9"
              y1="25.5"
              x2="45.3"
              y2="45.5"
              stroke="var(--ap-accent)"
              strokeWidth="3"
              strokeLinecap="round"
            />
          </svg>
        </Link>
        {onShare && (
          <div className="ap-nav__right">
            <button
              className="ap-nav__icon-btn"
              onClick={onShare}
              aria-label="Share profile"
            >
              <ShareNetwork size={18} />
            </button>
          </div>
        )}
      </div>
    </nav>
  );
}
